export const apiUrl = process.env.REACT_APP_API_URL
export const baseUrl = process.env.REACT_APP_BASE_URL
export const stripePublishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY
export const ziprecruiterApiKey = process.env.REACT_APP_ZIPRECRUITER_API_KEY
export const ziprecruiterApiUrl = process.env.REACT_APP_ZIPRECRUITER_API_URL



// WEBPACK FOOTER //
// ./src/app/_CONSTANTS.jsx